<template>
  <div class="page-container">
    <!--<a-tabs :activeKey="activeKey" destroyInactiveTabPane @change="changeTab">-->
    <!--  <a-tab-pane v-for="(item, index) in tabList" :key="item.key" :tab="item.tab">-->
    <!--    <CollapseResource-->
    <!--      :title="item.tab"-->
    <!--      :actionUrl="item.url"-->
    <!--      sortDictCode="research_sort"-->
    <!--      :actionType="item.key"-->
    <!--    />-->
    <!--  </a-tab-pane>-->
    <!--</a-tabs>-->
    <CollapseResource
      :title="tabList[0].tab"
      :actionUrl="tabList[0].url"
      sortDictCode="research_sort"
      :actionType="tabList[0].key"
    />
  </div>
</template>
<script>
import CollapseResource from '@/comUi/CollapseResource'

export default {
  name: 'SubjectResearch',
  components: {
    CollapseResource,
  },
  data() {
    return {
      activeKey: '1',
      tabList: [
        {
          tab: '课题研究',
          key: '1',
          url: 'resourceResearch',
        },
      ],
    }
  },
  methods: {
    changeTab(key) {
      this.activeKey = key
    },
  },
}
</script>
